import { IconName } from '@fortawesome/fontawesome-svg-core';

const FILE_ICON_MAP: Record<string, IconName> = {
  pdf: 'file-pdf',
  doc: 'file-word',
  docx: 'file-word',
  xls: 'file-excel',
  xlsx: 'file-excel',
  csv: 'file-excel',
  ppt: 'file-powerpoint',
  pptx: 'file-powerpoint',
  png: 'file-image',
  jpg: 'file-image',
  jpeg: 'file-image',
  gif: 'file-image',
  svg: 'file-image',
  webp: 'file-image',
  mp4: 'file-video',
  mov: 'file-video',
  avi: 'file-video',
  mkv: 'file-video',
  mp3: 'file-audio',
  wav: 'file-audio',
  ogg: 'file-audio',
  zip: 'file-zipper',
  rar: 'file-zipper',
  '7z': 'file-zipper',
  tar: 'file-zipper',
  gz: 'file-zipper',
  txt: 'file-lines',
  md: 'file-lines',
  eml: 'envelope',
  msg: 'envelope',
};

export const getFileIcon = (filename: string): IconName => {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return FILE_ICON_MAP[ext] ?? 'file';
};

type MimeTypeColorKey = 'word' | 'excel' | 'powerpoint' | 'pdf' | 'email' | 'image' | 'video' | 'zip';

const FILE_MIMETYPE_MAP: Record<string, MimeTypeColorKey> = {
  pdf: 'pdf',
  doc: 'word',
  docx: 'word',
  xls: 'excel',
  xlsx: 'excel',
  csv: 'excel',
  ppt: 'powerpoint',
  pptx: 'powerpoint',
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
  gif: 'image',
  svg: 'image',
  webp: 'image',
  mp4: 'video',
  mov: 'video',
  avi: 'video',
  mkv: 'video',
  zip: 'zip',
  rar: 'zip',
  '7z': 'zip',
  tar: 'zip',
  gz: 'zip',
  eml: 'email',
  msg: 'email',
};

export const getFileMimeTypeKey = (filename: string): MimeTypeColorKey | null => {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return FILE_MIMETYPE_MAP[ext] ?? null;
};
